var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-1 dropdown-content",
    class: _vm.classes
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.copyUrlSrc
    }
  }, [!_vm.show ? _c('p', {
    staticClass: "d-inline",
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(" Copy Link "), _c('font-awesome-icon', {
    attrs: {
      "size": "lg",
      "icon": "copy"
    }
  })], 1) : _vm._e(), _vm.show ? _c('p', {
    staticClass: "d-inline",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" Copied! "), _c('font-awesome-icon', {
    attrs: {
      "size": "lg",
      "icon": "check-circle"
    }
  })], 1) : _vm._e()])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }